export default "__VITE_ASSET__DIKaNGv4__"